// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyPlaceholder-module__font-s-10___W68Y1 {
  font-size: 10px !important;
}

.EmptyPlaceholder-module__font-s-12___H7Hlg {
  font-size: 12px !important;
}

.EmptyPlaceholder-module__font-s-13___p1u1X {
  font-size: 13px !important;
}

.EmptyPlaceholder-module__font-s-14___NvzIK {
  font-size: 14px !important;
}

.EmptyPlaceholder-module__font-s-15___He2DZ {
  font-size: 15px !important;
}

.EmptyPlaceholder-module__font-s-16___aWbky {
  font-size: 16px !important;
}

.EmptyPlaceholder-module__font-s-18___vq8ev {
  font-size: 18px !important;
}

.EmptyPlaceholder-module__font-s-20___kOv8H {
  font-size: 20px !important;
}

.EmptyPlaceholder-module__font-s-22___c8cEi {
  font-size: 22px !important;
}

.EmptyPlaceholder-module__font-s-28___HkiEg {
  font-size: 28px !important;
}

.EmptyPlaceholder-module__font-w-400___jEofu {
  font-weight: 400 !important;
}

.EmptyPlaceholder-module__font-w-500___wIhlH {
  font-weight: 500 !important;
}

.EmptyPlaceholder-module__font-w-600___n9s5Q {
  font-weight: 600 !important;
}

.EmptyPlaceholder-module__font-w-700___QWRfq {
  font-weight: 700 !important;
}

.EmptyPlaceholder-module__p-5___EPH4H {
  padding: 5px !important;
}

.EmptyPlaceholder-module__p-12___QPy6z {
  padding: 12px !important;
}

.EmptyPlaceholder-module__p-16___HDfNY {
  padding: 16px !important;
}

.EmptyPlaceholder-module__p-30___h4tIR {
  padding: 30px !important;
}

.EmptyPlaceholder-module__p-b-0___ybuEg {
  padding-bottom: 0 !important;
}

.EmptyPlaceholder-module__p-b-5___xV5i2 {
  padding-bottom: 5px !important;
}

.EmptyPlaceholder-module__p-b-10___fucgZ {
  padding-bottom: 10px !important;
}

.EmptyPlaceholder-module__p-b-12___v0gg5 {
  padding-bottom: 12px !important;
}

.EmptyPlaceholder-module__p-b-16___KA3NE {
  padding-bottom: 16px !important;
}

.EmptyPlaceholder-module__p-b-18___CfoMi {
  padding-bottom: 18px !important;
}

.EmptyPlaceholder-module__p-b-20___TLKr6 {
  padding-bottom: 20px !important;
}

.EmptyPlaceholder-module__p-b-25___sA9Gh {
  padding-bottom: 25px !important;
}

.EmptyPlaceholder-module__p-b-30___s8TZz {
  padding-bottom: 30px !important;
}

.EmptyPlaceholder-module__p-b-50___BOEt0 {
  padding-bottom: 50px !important;
}

.EmptyPlaceholder-module__p-t-0___mVZkS {
  padding-top: 0 !important;
}

.EmptyPlaceholder-module__p-t-12___LP1W0 {
  padding-top: 12px !important;
}

.EmptyPlaceholder-module__p-t-16___iODyu {
  padding-top: 16px !important;
}

.EmptyPlaceholder-module__p-t-18___kwcYE {
  padding-top: 18px !important;
}

.EmptyPlaceholder-module__p-t-20___XssL9 {
  padding-top: 20px !important;
}

.EmptyPlaceholder-module__p-t-30___qL46u {
  padding-top: 30px !important;
}

.EmptyPlaceholder-module__p-t-40___M2Aq4 {
  padding-top: 40px !important;
}

.EmptyPlaceholder-module__p-t-50___V4aWo {
  padding-top: 50px !important;
}

.EmptyPlaceholder-module__p-l-20___dojyo {
  padding-left: 20px !important;
}

.EmptyPlaceholder-module__p-l-30___tHn80 {
  padding-left: 30px !important;
}

.EmptyPlaceholder-module__p-l-40___X_pCx {
  padding-left: 40px !important;
}

.EmptyPlaceholder-module__p-r-16___WZ3SD {
  padding-right: 16px !important;
}

.EmptyPlaceholder-module__p-r-20___E4OnD {
  padding-right: 20px !important;
}

.EmptyPlaceholder-module__p-r-30___Y8kab {
  padding-right: 30px !important;
}

.EmptyPlaceholder-module__p-r-50___w6T9N {
  padding-right: 50px !important;
}

.EmptyPlaceholder-module__p-r-60___KpRi2 {
  padding-right: 60px !important;
}

.EmptyPlaceholder-module__m-b-1___BJKPf {
  margin-bottom: 1px !important;
}

.EmptyPlaceholder-module__m-b-2___Nhght {
  margin-bottom: 2px !important;
}

.EmptyPlaceholder-module__m-b-6___uZQUl {
  margin-bottom: 6px !important;
}

.EmptyPlaceholder-module__m-b-8___QJtZz {
  margin-bottom: 8px !important;
}

.EmptyPlaceholder-module__m-b-10___fB_RE {
  margin-bottom: 10px !important;
}

.EmptyPlaceholder-module__m-b-14___M04Iv {
  margin-bottom: 14px !important;
}

.EmptyPlaceholder-module__m-b-16___tzwjV {
  margin-bottom: 16px !important;
}

.EmptyPlaceholder-module__m-b-20___Dm9un {
  margin-bottom: 20px !important;
}

.EmptyPlaceholder-module__m-b-22___j8xUx {
  margin-bottom: 22px !important;
}

.EmptyPlaceholder-module__m-b-24___5M8WB {
  margin-bottom: 24px !important;
}

.EmptyPlaceholder-module__m-b-30___L15z0 {
  margin-bottom: 30px !important;
}

.EmptyPlaceholder-module__m-b-32___eXIwy {
  margin-bottom: 32px !important;
}

.EmptyPlaceholder-module__m-b-40___lNe0G {
  margin-bottom: 40px !important;
}

.EmptyPlaceholder-module__m-t-2___ANZzQ {
  margin-top: 2px !important;
}

.EmptyPlaceholder-module__m-t-3___m2Ko1 {
  margin-top: 3px !important;
}

.EmptyPlaceholder-module__m-t-4___Kt0EJ {
  margin-top: 4px !important;
}

.EmptyPlaceholder-module__m-t-5___D4mxF {
  margin-top: 5px !important;
}

.EmptyPlaceholder-module__m-t-8___pmAwr {
  margin-top: 8px !important;
}

.EmptyPlaceholder-module__m-t-10___ZF_YQ {
  margin-top: 10px !important;
}

.EmptyPlaceholder-module__m-t-15___yMuXq {
  margin-top: 15px !important;
}

.EmptyPlaceholder-module__m-t-16___TeJlv {
  margin-top: 16px !important;
}

.EmptyPlaceholder-module__m-t-20___cYTMq {
  margin-top: 20px !important;
}

.EmptyPlaceholder-module__m-t-22___voiux {
  margin-top: 22px !important;
}

.EmptyPlaceholder-module__m-t-30___W6TjV {
  margin-top: 30px !important;
}

.EmptyPlaceholder-module__m-t-32___sJ8Mo {
  margin-top: 32px !important;
}

.EmptyPlaceholder-module__m-l-auto___zQSoT {
  margin-left: auto !important;
}

.EmptyPlaceholder-module__m-l-4___MJYPq {
  margin-left: 4px !important;
}

.EmptyPlaceholder-module__m-l-5___NCSRI {
  margin-left: 5px !important;
}

.EmptyPlaceholder-module__m-l-6___p5B0s {
  margin-left: 6px !important;
}

.EmptyPlaceholder-module__m-l-8___tS2yj {
  margin-left: 8px !important;
}

.EmptyPlaceholder-module__m-l-10___aYbRz {
  margin-left: 10px !important;
}

.EmptyPlaceholder-module__m-l-16___f3c4m {
  margin-left: 16px !important;
}

.EmptyPlaceholder-module__m-l-20___cENcG {
  margin-left: 20px !important;
}

.EmptyPlaceholder-module__m-l-24___AllvQ {
  margin-left: 24px !important;
}

.EmptyPlaceholder-module__m-l-30___X8djk {
  margin-left: 30px !important;
}

.EmptyPlaceholder-module__m-l-35___FpnMA {
  margin-left: 35px !important;
}

.EmptyPlaceholder-module__m-l-40___PoFBE {
  margin-left: 40px !important;
}

.EmptyPlaceholder-module__m-r-8___l5MXU {
  margin-right: 8px !important;
}

.EmptyPlaceholder-module__m-r-10___nNFs7 {
  margin-right: 10px !important;
}

.EmptyPlaceholder-module__m-r-16___ce_Ep {
  margin-right: 16px !important;
}

.EmptyPlaceholder-module__m-r-20___CXrr9 {
  margin-right: 20px !important;
}

.EmptyPlaceholder-module__m-r-24___AIskB {
  margin-right: 24px !important;
}

.EmptyPlaceholder-module__m-r-30___lbVHa {
  margin-right: 30px !important;
}

.EmptyPlaceholder-module__m-r-40___WVDET {
  margin-right: 40px !important;
}

.EmptyPlaceholder-module__border-r-3___Ecx4g {
  border-radius: 3px !important;
}

.EmptyPlaceholder-module__border-r-4___DPefc {
  border-radius: 4px !important;
}

.EmptyPlaceholder-module__border-r-6___EdKp6 {
  border-radius: 6px !important;
}

.EmptyPlaceholder-module__border-r-10___zHfBp {
  border-radius: 10px !important;
}

.EmptyPlaceholder-module__border-r-12___OyGoL {
  border-radius: 12px !important;
}

.EmptyPlaceholder-module__border-r-16___IILxp {
  border-radius: 16px !important;
}

.EmptyPlaceholder-module__border-r-50___IDfiB {
  border-radius: 50% !important;
}

.EmptyPlaceholder-module__primary-border___eKnQf {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.EmptyPlaceholder-module__primary-border-b___Qn4qm {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.EmptyPlaceholder-module__primary-border-t___noqrP {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.EmptyPlaceholder-module__primary-border-l___slpgN {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.EmptyPlaceholder-module__primary-border-r___mwaNa {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.EmptyPlaceholder-module__secondary-border___U8r0b {
  border: 1px solid #637768;
}

.EmptyPlaceholder-module__secondary-border-b___oMMRv {
  border-bottom: 1px solid #637768;
}

.EmptyPlaceholder-module__secondary-border-t___fp0g5 {
  border-top: 1px solid #637768;
}

.EmptyPlaceholder-module__secondary-border-l___q30Bl {
  border-left: 1px solid #637768;
}

.EmptyPlaceholder-module__secondary-border-r___zLYI2 {
  border-right: 1px solid #637768;
}

.EmptyPlaceholder-module__gap-0___Um65V {
  gap: 0 !important;
}

.EmptyPlaceholder-module__gap-2___Awr7W {
  gap: 2px !important;
}

.EmptyPlaceholder-module__gap-4___qzIUw {
  gap: 4px !important;
}

.EmptyPlaceholder-module__gap-5___sDe9j {
  gap: 5px !important;
}

.EmptyPlaceholder-module__gap-6___JmSIk {
  gap: 6px !important;
}

.EmptyPlaceholder-module__gap-8___SAGQ3 {
  gap: 8px !important;
}

.EmptyPlaceholder-module__gap-10___EaYYJ {
  gap: 10px !important;
}

.EmptyPlaceholder-module__gap-12___piHfc {
  gap: 12px !important;
}

.EmptyPlaceholder-module__gap-14___f83F2 {
  gap: 14px !important;
}

.EmptyPlaceholder-module__gap-16___JAnqB {
  gap: 16px !important;
}

.EmptyPlaceholder-module__gap-18___hUdkV {
  gap: 18px !important;
}

.EmptyPlaceholder-module__gap-20___Z7PEl {
  gap: 20px !important;
}

.EmptyPlaceholder-module__gap-24___orglk {
  gap: 24px !important;
}

.EmptyPlaceholder-module__gap-26___jWszm {
  gap: 26px !important;
}

.EmptyPlaceholder-module__gap-30___n1iLU {
  gap: 30px !important;
}

.EmptyPlaceholder-module__gap-32___cYeT1 {
  gap: 32px !important;
}

.EmptyPlaceholder-module__gap-40___xjAxV {
  gap: 40px !important;
}

.EmptyPlaceholder-module__gap-50___JXj0l {
  gap: 50px !important;
}

.EmptyPlaceholder-module__flex-1___lBPXa {
  flex: 1;
}

.EmptyPlaceholder-module__flex-none___ZhkHl {
  flex: none !important;
}

.EmptyPlaceholder-module__flex-column___ElFtY {
  display: flex;
  flex-direction: column !important;
}

.EmptyPlaceholder-module__flex-row___rFCop {
  display: flex;
  flex-direction: row !important;
}

.EmptyPlaceholder-module__vertically-centered___gvh0M {
  display: flex;
  align-items: center !important;
}

.EmptyPlaceholder-module__horizontally-centered___XeHTF {
  display: flex;
  justify-content: center !important;
}

.EmptyPlaceholder-module__horizontally-end___Ofedl {
  display: flex;
  justify-content: end !important;
}

.EmptyPlaceholder-module__vertically-start____wccO {
  display: flex;
  align-items: start !important;
}

.EmptyPlaceholder-module__space-between___hOF7J {
  display: flex;
  justify-content: space-between !important;
}

.EmptyPlaceholder-module__flex-wrap___w2VM8 {
  flex-wrap: wrap !important;
}

.EmptyPlaceholder-module__height-100___C56GN {
  height: 100%;
}

.EmptyPlaceholder-module__width-50___L3gxY {
  width: 50% !important;
}

.EmptyPlaceholder-module__width-100___MR9rk {
  width: 100%;
}

.EmptyPlaceholder-module__cursor-pointer___xcAJS {
  cursor: pointer;
}

.EmptyPlaceholder-module__cursor-not-allowed___zc2km {
  cursor: not-allowed !important;
}

.EmptyPlaceholder-module__absolute-centered___GBS8W {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.EmptyPlaceholder-module__absolute___ojevj {
  position: absolute;
}

.EmptyPlaceholder-module__relative___mIrkz {
  position: relative;
}

.EmptyPlaceholder-module__fixed___SjTzZ {
  position: fixed;
}

.EmptyPlaceholder-module__visible___V9W34 {
  opacity: 1;
}

.EmptyPlaceholder-module__invisible___vQTUV {
  opacity: 0;
}

.EmptyPlaceholder-module__col-90___fZtWV {
  width: 90% !important;
}

.EmptyPlaceholder-module__col-auto___WK8Ih {
  width: auto !important;
}

.EmptyPlaceholder-module__medical-tabs___Vf8wm {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.EmptyPlaceholder-module__medical-table-new___g1QFd {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd::-webkit-scrollbar-track {
  display: none;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd.EmptyPlaceholder-module__no-pagination___Gsf4c {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd.EmptyPlaceholder-module__no-pagination___Gsf4c:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd.EmptyPlaceholder-module__no-pagination___Gsf4c::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.EmptyPlaceholder-module__medical-table-new___g1QFd.EmptyPlaceholder-module__no-pagination___Gsf4c::-webkit-scrollbar-track {
  display: none;
}

.EmptyPlaceholder-module__medical-table-empty___TgJPw {
  padding: 14px 40px !important;
}

.EmptyPlaceholder-module__icon-btn___Pyat1 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.EmptyPlaceholder-module__search-icon___nBDzI {
  width: 24px;
  height: 24px;
  align-self: center;
}

.EmptyPlaceholder-module__disable-select___OzcBg {
  user-select: none;
}

.EmptyPlaceholder-module__break-word___hvIpo {
  word-break: break-word;
}

.EmptyPlaceholder-module__popup-clear-btn___g88HS {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.EmptyPlaceholder-module__scroll-m-b-20___wMKH_ {
  scroll-margin-bottom: 20px;
}

.EmptyPlaceholder-module__container___h0OK1 {
  height: 100%;
}
.EmptyPlaceholder-module__container___h0OK1 .EmptyPlaceholder-module__text___RU8se {
  font-family: var(--font-family);
  font-weight: 200;
  font-size: 1.5rem;
  color: #a3a3a3;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/EmptyPlaceholder/EmptyPlaceholder.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;AA8pBF;AA5pBE;EEqBA,+BApBO;EAqBP,gBC3BY;ED4BZ,iBAAA;EFrBE,cAAA;AAgqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: 100%;\n\n  .text {\n    @include get-font($roboto, $extra-light, x-large);\n    color: get-color(gray, medium-dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `EmptyPlaceholder-module__font-s-10___W68Y1`,
	"fontS12": `EmptyPlaceholder-module__font-s-12___H7Hlg`,
	"fontS13": `EmptyPlaceholder-module__font-s-13___p1u1X`,
	"fontS14": `EmptyPlaceholder-module__font-s-14___NvzIK`,
	"fontS15": `EmptyPlaceholder-module__font-s-15___He2DZ`,
	"fontS16": `EmptyPlaceholder-module__font-s-16___aWbky`,
	"fontS18": `EmptyPlaceholder-module__font-s-18___vq8ev`,
	"fontS20": `EmptyPlaceholder-module__font-s-20___kOv8H`,
	"fontS22": `EmptyPlaceholder-module__font-s-22___c8cEi`,
	"fontS28": `EmptyPlaceholder-module__font-s-28___HkiEg`,
	"fontW400": `EmptyPlaceholder-module__font-w-400___jEofu`,
	"fontW500": `EmptyPlaceholder-module__font-w-500___wIhlH`,
	"fontW600": `EmptyPlaceholder-module__font-w-600___n9s5Q`,
	"fontW700": `EmptyPlaceholder-module__font-w-700___QWRfq`,
	"p5": `EmptyPlaceholder-module__p-5___EPH4H`,
	"p12": `EmptyPlaceholder-module__p-12___QPy6z`,
	"p16": `EmptyPlaceholder-module__p-16___HDfNY`,
	"p30": `EmptyPlaceholder-module__p-30___h4tIR`,
	"pB0": `EmptyPlaceholder-module__p-b-0___ybuEg`,
	"pB5": `EmptyPlaceholder-module__p-b-5___xV5i2`,
	"pB10": `EmptyPlaceholder-module__p-b-10___fucgZ`,
	"pB12": `EmptyPlaceholder-module__p-b-12___v0gg5`,
	"pB16": `EmptyPlaceholder-module__p-b-16___KA3NE`,
	"pB18": `EmptyPlaceholder-module__p-b-18___CfoMi`,
	"pB20": `EmptyPlaceholder-module__p-b-20___TLKr6`,
	"pB25": `EmptyPlaceholder-module__p-b-25___sA9Gh`,
	"pB30": `EmptyPlaceholder-module__p-b-30___s8TZz`,
	"pB50": `EmptyPlaceholder-module__p-b-50___BOEt0`,
	"pT0": `EmptyPlaceholder-module__p-t-0___mVZkS`,
	"pT12": `EmptyPlaceholder-module__p-t-12___LP1W0`,
	"pT16": `EmptyPlaceholder-module__p-t-16___iODyu`,
	"pT18": `EmptyPlaceholder-module__p-t-18___kwcYE`,
	"pT20": `EmptyPlaceholder-module__p-t-20___XssL9`,
	"pT30": `EmptyPlaceholder-module__p-t-30___qL46u`,
	"pT40": `EmptyPlaceholder-module__p-t-40___M2Aq4`,
	"pT50": `EmptyPlaceholder-module__p-t-50___V4aWo`,
	"pL20": `EmptyPlaceholder-module__p-l-20___dojyo`,
	"pL30": `EmptyPlaceholder-module__p-l-30___tHn80`,
	"pL40": `EmptyPlaceholder-module__p-l-40___X_pCx`,
	"pR16": `EmptyPlaceholder-module__p-r-16___WZ3SD`,
	"pR20": `EmptyPlaceholder-module__p-r-20___E4OnD`,
	"pR30": `EmptyPlaceholder-module__p-r-30___Y8kab`,
	"pR50": `EmptyPlaceholder-module__p-r-50___w6T9N`,
	"pR60": `EmptyPlaceholder-module__p-r-60___KpRi2`,
	"mB1": `EmptyPlaceholder-module__m-b-1___BJKPf`,
	"mB2": `EmptyPlaceholder-module__m-b-2___Nhght`,
	"mB6": `EmptyPlaceholder-module__m-b-6___uZQUl`,
	"mB8": `EmptyPlaceholder-module__m-b-8___QJtZz`,
	"mB10": `EmptyPlaceholder-module__m-b-10___fB_RE`,
	"mB14": `EmptyPlaceholder-module__m-b-14___M04Iv`,
	"mB16": `EmptyPlaceholder-module__m-b-16___tzwjV`,
	"mB20": `EmptyPlaceholder-module__m-b-20___Dm9un`,
	"mB22": `EmptyPlaceholder-module__m-b-22___j8xUx`,
	"mB24": `EmptyPlaceholder-module__m-b-24___5M8WB`,
	"mB30": `EmptyPlaceholder-module__m-b-30___L15z0`,
	"mB32": `EmptyPlaceholder-module__m-b-32___eXIwy`,
	"mB40": `EmptyPlaceholder-module__m-b-40___lNe0G`,
	"mT2": `EmptyPlaceholder-module__m-t-2___ANZzQ`,
	"mT3": `EmptyPlaceholder-module__m-t-3___m2Ko1`,
	"mT4": `EmptyPlaceholder-module__m-t-4___Kt0EJ`,
	"mT5": `EmptyPlaceholder-module__m-t-5___D4mxF`,
	"mT8": `EmptyPlaceholder-module__m-t-8___pmAwr`,
	"mT10": `EmptyPlaceholder-module__m-t-10___ZF_YQ`,
	"mT15": `EmptyPlaceholder-module__m-t-15___yMuXq`,
	"mT16": `EmptyPlaceholder-module__m-t-16___TeJlv`,
	"mT20": `EmptyPlaceholder-module__m-t-20___cYTMq`,
	"mT22": `EmptyPlaceholder-module__m-t-22___voiux`,
	"mT30": `EmptyPlaceholder-module__m-t-30___W6TjV`,
	"mT32": `EmptyPlaceholder-module__m-t-32___sJ8Mo`,
	"mLAuto": `EmptyPlaceholder-module__m-l-auto___zQSoT`,
	"mL4": `EmptyPlaceholder-module__m-l-4___MJYPq`,
	"mL5": `EmptyPlaceholder-module__m-l-5___NCSRI`,
	"mL6": `EmptyPlaceholder-module__m-l-6___p5B0s`,
	"mL8": `EmptyPlaceholder-module__m-l-8___tS2yj`,
	"mL10": `EmptyPlaceholder-module__m-l-10___aYbRz`,
	"mL16": `EmptyPlaceholder-module__m-l-16___f3c4m`,
	"mL20": `EmptyPlaceholder-module__m-l-20___cENcG`,
	"mL24": `EmptyPlaceholder-module__m-l-24___AllvQ`,
	"mL30": `EmptyPlaceholder-module__m-l-30___X8djk`,
	"mL35": `EmptyPlaceholder-module__m-l-35___FpnMA`,
	"mL40": `EmptyPlaceholder-module__m-l-40___PoFBE`,
	"mR8": `EmptyPlaceholder-module__m-r-8___l5MXU`,
	"mR10": `EmptyPlaceholder-module__m-r-10___nNFs7`,
	"mR16": `EmptyPlaceholder-module__m-r-16___ce_Ep`,
	"mR20": `EmptyPlaceholder-module__m-r-20___CXrr9`,
	"mR24": `EmptyPlaceholder-module__m-r-24___AIskB`,
	"mR30": `EmptyPlaceholder-module__m-r-30___lbVHa`,
	"mR40": `EmptyPlaceholder-module__m-r-40___WVDET`,
	"borderR3": `EmptyPlaceholder-module__border-r-3___Ecx4g`,
	"borderR4": `EmptyPlaceholder-module__border-r-4___DPefc`,
	"borderR6": `EmptyPlaceholder-module__border-r-6___EdKp6`,
	"borderR10": `EmptyPlaceholder-module__border-r-10___zHfBp`,
	"borderR12": `EmptyPlaceholder-module__border-r-12___OyGoL`,
	"borderR16": `EmptyPlaceholder-module__border-r-16___IILxp`,
	"borderR50": `EmptyPlaceholder-module__border-r-50___IDfiB`,
	"primaryBorder": `EmptyPlaceholder-module__primary-border___eKnQf`,
	"primaryBorderB": `EmptyPlaceholder-module__primary-border-b___Qn4qm`,
	"primaryBorderT": `EmptyPlaceholder-module__primary-border-t___noqrP`,
	"primaryBorderL": `EmptyPlaceholder-module__primary-border-l___slpgN`,
	"primaryBorderR": `EmptyPlaceholder-module__primary-border-r___mwaNa`,
	"secondaryBorder": `EmptyPlaceholder-module__secondary-border___U8r0b`,
	"secondaryBorderB": `EmptyPlaceholder-module__secondary-border-b___oMMRv`,
	"secondaryBorderT": `EmptyPlaceholder-module__secondary-border-t___fp0g5`,
	"secondaryBorderL": `EmptyPlaceholder-module__secondary-border-l___q30Bl`,
	"secondaryBorderR": `EmptyPlaceholder-module__secondary-border-r___zLYI2`,
	"gap0": `EmptyPlaceholder-module__gap-0___Um65V`,
	"gap2": `EmptyPlaceholder-module__gap-2___Awr7W`,
	"gap4": `EmptyPlaceholder-module__gap-4___qzIUw`,
	"gap5": `EmptyPlaceholder-module__gap-5___sDe9j`,
	"gap6": `EmptyPlaceholder-module__gap-6___JmSIk`,
	"gap8": `EmptyPlaceholder-module__gap-8___SAGQ3`,
	"gap10": `EmptyPlaceholder-module__gap-10___EaYYJ`,
	"gap12": `EmptyPlaceholder-module__gap-12___piHfc`,
	"gap14": `EmptyPlaceholder-module__gap-14___f83F2`,
	"gap16": `EmptyPlaceholder-module__gap-16___JAnqB`,
	"gap18": `EmptyPlaceholder-module__gap-18___hUdkV`,
	"gap20": `EmptyPlaceholder-module__gap-20___Z7PEl`,
	"gap24": `EmptyPlaceholder-module__gap-24___orglk`,
	"gap26": `EmptyPlaceholder-module__gap-26___jWszm`,
	"gap30": `EmptyPlaceholder-module__gap-30___n1iLU`,
	"gap32": `EmptyPlaceholder-module__gap-32___cYeT1`,
	"gap40": `EmptyPlaceholder-module__gap-40___xjAxV`,
	"gap50": `EmptyPlaceholder-module__gap-50___JXj0l`,
	"flex1": `EmptyPlaceholder-module__flex-1___lBPXa`,
	"flexNone": `EmptyPlaceholder-module__flex-none___ZhkHl`,
	"flexColumn": `EmptyPlaceholder-module__flex-column___ElFtY`,
	"flexRow": `EmptyPlaceholder-module__flex-row___rFCop`,
	"verticallyCentered": `EmptyPlaceholder-module__vertically-centered___gvh0M`,
	"horizontallyCentered": `EmptyPlaceholder-module__horizontally-centered___XeHTF`,
	"horizontallyEnd": `EmptyPlaceholder-module__horizontally-end___Ofedl`,
	"verticallyStart": `EmptyPlaceholder-module__vertically-start____wccO`,
	"spaceBetween": `EmptyPlaceholder-module__space-between___hOF7J`,
	"flexWrap": `EmptyPlaceholder-module__flex-wrap___w2VM8`,
	"height100": `EmptyPlaceholder-module__height-100___C56GN`,
	"width50": `EmptyPlaceholder-module__width-50___L3gxY`,
	"width100": `EmptyPlaceholder-module__width-100___MR9rk`,
	"cursorPointer": `EmptyPlaceholder-module__cursor-pointer___xcAJS`,
	"cursorNotAllowed": `EmptyPlaceholder-module__cursor-not-allowed___zc2km`,
	"absoluteCentered": `EmptyPlaceholder-module__absolute-centered___GBS8W`,
	"absolute": `EmptyPlaceholder-module__absolute___ojevj`,
	"relative": `EmptyPlaceholder-module__relative___mIrkz`,
	"fixed": `EmptyPlaceholder-module__fixed___SjTzZ`,
	"visible": `EmptyPlaceholder-module__visible___V9W34`,
	"invisible": `EmptyPlaceholder-module__invisible___vQTUV`,
	"col90": `EmptyPlaceholder-module__col-90___fZtWV`,
	"colAuto": `EmptyPlaceholder-module__col-auto___WK8Ih`,
	"medicalTabs": `EmptyPlaceholder-module__medical-tabs___Vf8wm`,
	"medicalTableNew": `EmptyPlaceholder-module__medical-table-new___g1QFd`,
	"noPagination": `EmptyPlaceholder-module__no-pagination___Gsf4c`,
	"medicalTableEmpty": `EmptyPlaceholder-module__medical-table-empty___TgJPw`,
	"iconBtn": `EmptyPlaceholder-module__icon-btn___Pyat1`,
	"searchIcon": `EmptyPlaceholder-module__search-icon___nBDzI`,
	"disableSelect": `EmptyPlaceholder-module__disable-select___OzcBg`,
	"breakWord": `EmptyPlaceholder-module__break-word___hvIpo`,
	"popupClearBtn": `EmptyPlaceholder-module__popup-clear-btn___g88HS`,
	"scrollMB20": `EmptyPlaceholder-module__scroll-m-b-20___wMKH_`,
	"container": `EmptyPlaceholder-module__container___h0OK1`,
	"text": `EmptyPlaceholder-module__text___RU8se`
};
module.exports = ___CSS_LOADER_EXPORT___;
